// extracted by mini-css-extract-plugin
export default {"wrapper":"Blog_wrapper__s1DjY","inner":"Blog_inner__F3Awf"};